import React from 'react';
import {Box, Grid } from '@mui/material';
import {SubCategory} from "@/types";
import {useResizeHook} from "@/lib";
import {useTheme} from "@mui/material/styles";
import ServiceCategoryRowGallery from "@/ui/service-category-row/service-category-row-gallery";
import ServiceCategoryRowContent from "@/ui/service-category-row/service-category-row-content";


type ServiceCategoryRowProps = {
    category: SubCategory;
    i: number;
    showPoints: boolean;
    alternate?: boolean;
    key:number;
}

const ServiceCategoryRow = ({
                                category,
                                key,
                                showPoints,
                                alternate
                            }: ServiceCategoryRowProps) => {

    const {lessThanMuiMd} = useResizeHook();
    const theme = useTheme();

    const localTheme = alternate ? theme.custom.brandedAlternateBackgroundBlock: theme.custom.brandedBackgroundBlock;

    const blockTheme =  {
        backgroundImage: `linear-gradient(${localTheme.direction}, ${localTheme.start}, ${localTheme.end})`,
        '& h1, & h2, & h3, & h4, & h5, & h6, & a': {
            color: localTheme.color,
        },
        '& a':{
            borderColor: localTheme.color,
        }
    }


    const galleryContent = <ServiceCategoryRowGallery images={category?.images} />;

    const content = <ServiceCategoryRowContent
        showPoints={showPoints}
        category={category}
        alternate={alternate}
    />


    return (
        <Box key={key} sx={{...blockTheme,
                [theme.breakpoints.down('md')]: {
                    py:8
                },
                [theme.breakpoints.down('sm')]: {
                    py:3
                },
        }}>
            <Box
                sx={(theme) => ({
                    backgroundColor: localTheme.background,
                    py: 10,
                    px: 3,
                    [theme.breakpoints.down('md')]: {
                        px: 3,
                        py: 6,
                        mt: 4,
                        // width: '90%',
                        mx: 'auto',
                        borderRadius: '10px',
                        textAlign: 'center'
                    },
                    [theme.breakpoints.down('sm')]: {
                        py: 2,
                    },

                })}
            >
                <Box sx={{justifyContent: 'center', m: 'auto'}}>
                    <Grid
                        container
                        spacing={5}
                        sx={{
                            textAlign: 'center'
                        }}
                    >
                        {lessThanMuiMd ? content : alternate ? content : galleryContent}
                        {/*always hide from here in small viewports and show up in content component instead*/}
                        {lessThanMuiMd ? null : alternate ? galleryContent : content}
                    </Grid>
                </Box>
            </Box>

        </Box>
    );
};

export default ServiceCategoryRow;
